<template>
	<v-container class="mt-4  pr-4">
	  <v-row>
	  	<v-col cols="12">
	  		<v-card class="transparent elevation-0">
          <v-card-title primary-title class="pb-0">
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon small>mdi-refresh</v-icon>
            </v-btn>
          </v-card-title>
            
	  		  <v-card-title primary-title>
	  		    <v-spacer></v-spacer>
	  		  	<div class="text-center">
		  		    <span class="text-subtitle-1">Clases disponibles</span>
              <br/>
		  		    <span class="text-h4">{{ libres }}</span>
	  		  	</div>
	  		    <v-spacer></v-spacer>

	  		  </v-card-title>

	  		  <v-card-text>
	  		    <v-row>
              <v-col cols="12" md="6" lg="3" xl="2" v-for="(paq, i ) in paquetes" :key="i">
                <v-card class="shadowCard">
                  <v-card-title>
                    <v-spacer></v-spacer>
                    {{ paq.paquete }}
                    <v-spacer></v-spacer>
                  </v-card-title>
                  <v-card-text class="text-center">
                    <v-row justify="space-around">
                      <v-col cols="6">
                        <v-card class="text-center white--text" color="primary">
                          <v-card-title class="text-subtitle-1 pb-0">
                            <v-spacer></v-spacer>
                            Clases
                            <v-spacer></v-spacer>
                          </v-card-title>
                          <v-card-text class="text-h3 white--text pt-0">
                            {{ paq.cant_clases }}
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-col cols="6">
                        <v-card class="text-center white--text" color="black">
                          <v-card-title class="text-subtitle-1 pb-0">
                            <v-spacer></v-spacer>
                            Límite
                            <v-spacer></v-spacer>
                          </v-card-title>
                          <v-card-text class="text-h3 white--text pt-0">
                            {{ paq.limite_dias }}
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                    <br/>
                    <span class="text-h5 black--text"><b>Costo:</b>{{ formatoMoneda( paq.costo ) }}</span>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn 
                      color="orange"
                      tile
                      block
                      dark
                      outlined
                      @click="editItem(paq)"
                    >
                      COMPRAR
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
	  		    </v-row>
	  		  </v-card-text>
	  		</v-card>
	  	</v-col>
	  </v-row>

	  <!-- Dialogo de editar o agregar-->
	  <v-dialog
      v-model="dialog"
      max-width="400px"
      persistent
    >
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <span class="text-subtitle-1">
          	<strong>Paquete: {{ editedItem.paquete }}</strong>
          </span>
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text class="text-h5 text-center">
        	¿Estás seguro de realizar está compra?
        </v-card-text>

        <v-card-actions>
        	<v-btn color="yellow" small tile @click="close()">
            Cancelar
            <v-icon small right>mdi-cancel</v-icon>
          </v-btn>
        	<v-spacer></v-spacer>
        	<v-btn color="green" dark small tile @click="save()">
            Sí
            <v-icon small right>mdi-check</v-icon>
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-container>
</template>
<script>
  import { mapGetters } from 'vuex'
  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'

  import { Browser } from '@capacitor/browser';

  export default {

    mixins: [ validarErrores, funcionesExcel ],

    components:{
      Alerta,
      carga,
    },

    data: () => ({
      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      dialog: false,
      dialogDelete: false,
      
      editedIndex: -1,

      editedItem: {
        idpaquetes:0,
				paquete:'',
        cant_clases:0,
        costo:0,
        limite_dias:0,
				deleted:0,
				fecha_creacion:null,
      },

      defaultItem: {
        idpaquetes:0,
        paquete:'',
        cant_clases:0,
        costo:0,
        limite_dias:0,
        deleted:0,
        fecha_creacion:null,
      },

      // tabla
      paquetes: [],

      libres: 0
    }),

    computed: {
    	...mapGetters('login',['getdatosUsuarioFitHouse']),
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar categoria' : 'Editar categoria'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },

    },

    async created () {

      await this.initialize()
      await this.getCantidadClases()
    },

    methods: {
      initialize () {
      	this.cargar = true
        this.paquetes = []
        return this.$http.get('paquetes.list').then(response=>{
        	this.paquetes = response.body
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getCantidadClases () {
        this.cargar = true
        this.libres = 0
        return this.$http.get('mis.cantidad.clases/' + this.getdatosUsuarioFitHouse.idusuarios ).then(response=>{
          this.libres = response.body.cantidadClases
          this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      editItem (item) {
        this.editedIndex = this.paquetes.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.paquetes.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
      	this.cargar = true
        // Lo mandapos por el EP
        this.editedItem.deleted = 1
        this.$http.put('paquetes.update/' + this.editedItem.idpaquetes, this.editedItem).then(response=>{
        	this.cargar = true
        	this.closeDelete()
        	this.initialize()
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {

      	const payload = {
      		description: this.editedItem.paquete,
      		idpaquetes : this.editedItem.idpaquetes,
      		idusuarios : this.getdatosUsuarioFitHouse.idusuarios,
      		cant_clases: this.editedItem.cant_clases,
      		limite_dias: this.editedItem.limite_dias, 
      		amount     : this.editedItem.costo,
      		customer: {
      			name        : this.getdatosUsuarioFitHouse.nombre_completo,
      			last_name   : '',
      			phone_number: this.getdatosUsuarioFitHouse.telefono,
      			email       : this.getdatosUsuarioFitHouse.correo
      		}
      	}

	      this.cargar = true
        // Lo mandapos por el EP
        this.$http.post('pagos.add', payload).then( response=>{
          this.abrirNavegador( response.body.payment_method.url )
        	this.initialize()
        	this.cargar = false
      		this.close()
        }).catch( error =>{
        	this.validarError( error )
      	}).finally( () => { this.cargar = false })
      },

      async abrirNavegador( url ){
        await Browser.open({ url });
      },

      formatoMoneda(monto) {
        const formato = new Intl.NumberFormat('es-MX', {
          style: 'currency',
          currency: 'MXN',
        });

        return formato.format(monto);
      },
    },
  }
</script>


